module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/events-2015-10-07.paginators.json
// module id = 630
// module chunks = 2